export const MEMBER_RIBBONS_GRID_VARIANTS = {
  roster: {
    loading: 'roster-file-loading',
    error: 'roster-file-error',
    scroll: 'roster-file-ribbons-scroll',
    toolbar: 'roster-file-ribbons-toolbar',
    toolbarBtn: 'roster-file-ribbons-toolbar__btn',
    grid: 'roster-file-ribbons-grid',
    ribbonCard: 'roster-file-ribbon-card',
    ribbonCardLocked: 'roster-file-ribbon-card--locked',
    progress: 'roster-file-ribbon-progress',
    progressBarWrap: 'roster-file-ribbon-progress__bar-wrap',
    progressTrack: 'roster-file-ribbon-progress__track',
    progressTrackComplete: 'roster-file-ribbon-progress__track--complete',
    progressTrackEmpty: 'roster-file-ribbon-progress__track--empty',
    progressSegment: 'roster-file-ribbon-progress__segment',
    progressSegmentFilled: 'is-filled',
    progressLabel: 'roster-file-ribbon-progress__label',
    handle: 'roster-file-ribbon-handle',
    handleBtn: 'roster-file-ribbon-handle__btn',
    handleTooltip: 'roster-file-ribbon-handle__tooltip',
    name: 'roster-file-ribbon-name',
    info: 'roster-file-ribbon-info',
    infoBtn: 'roster-file-ribbon-info__btn',
    infoTooltip: 'roster-file-ribbon-info__tooltip',
    placeholder: 'roster-file-placeholder',
    gridClass(columnsPerRow) {
      return this.grid;
    },
  },
  dashboard: {
    loading: 'member-dashboard__panel-placeholder',
    error: 'member-dashboard__panel-placeholder member-dashboard__panel-placeholder--error',
    scroll: 'member-dashboard__ribbons-body',
    toolbar: 'member-dashboard__ribbons-toolbar',
    toolbarBtn: 'member-dashboard__ribbons-toolbar__btn',
    grid: 'member-dashboard__ribbons-grid',
    ribbonCard: 'member-dashboard__ribbon-card',
    ribbonCardLocked: 'member-dashboard__ribbon-card--locked',
    progress: 'member-dashboard__ribbon-progress',
    progressBarWrap: 'member-dashboard__ribbon-progress__bar-wrap',
    progressTrack: 'member-dashboard__ribbon-progress__track',
    progressTrackComplete: 'member-dashboard__ribbon-progress__track--complete',
    progressTrackEmpty: 'member-dashboard__ribbon-progress__track--empty',
    progressSegment: 'member-dashboard__ribbon-progress__segment',
    progressSegmentFilled: 'is-filled',
    progressLabel: 'member-dashboard__ribbon-progress__label',
    handle: 'member-dashboard__ribbon-handle',
    handleBtn: 'member-dashboard__ribbon-handle__btn',
    handleTooltip: 'member-dashboard__ribbon-handle__tooltip',
    name: 'member-dashboard__ribbon-name',
    info: 'member-dashboard__ribbon-info',
    infoBtn: 'member-dashboard__ribbon-info__btn',
    infoTooltip: 'member-dashboard__ribbon-info__tooltip',
    placeholder: 'member-dashboard__panel-placeholder',
    gridClass(columnsPerRow) {
      const cols = Math.min(4, Math.max(1, Number(columnsPerRow) || 4));
      return `${this.grid} ${this.grid}--cols-${cols}`;
    },
  },
};
